const requisites = {
  inn: 'ИНН',
  ogrn: 'ОГРН',
  kpp: 'КПП',
  okpo: 'ОКПО',
  organization: 'Организация',
  dateRegistration: 'Зарегистрирован',
  contragent: 'Контрагент',
  generalDirector: 'Генеральный директор',
  salesOrg: 'СбОрг',
  salesOrganization: 'Сбытовая организация',
  founders: 'Учредители',
  aboutCompany: 'О компании',
  branch: 'Филиал',
};

export default requisites;
